module.exports = __webpack_public_path__ + "static/mujeres006-2ffb90675fb9a3bf222bd4851760bffd.jpg";